import { Component, Input, Output, EventEmitter, signal, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { League } from '../../services/league';
import { Modal } from '../modal/modal';

@Component({
  selector: 'app-league-form-modal',
  imports: [CommonModule, FormsModule, Modal],
  templateUrl: './league-form-modal.html',
  styleUrl: './league-form-modal.css',
})
export class LeagueFormModal {
  @Input({ required: true }) isOpen!: Signal<boolean>;
  @Input() isEditing = false;
  @Input() editingAsCommissioner = false;
  @Input() error: string | null = null;
  @Input() league: League = {
    name: '',
    max_teams: 12,
    team_budget: 200,
    roster_size: 16,
    team_name: '',
  };

  @Output() saved = new EventEmitter<League>();
  @Output() closed = new EventEmitter<void>();

  get title(): string {
    if (!this.isEditing) return 'Create New League';
    return this.editingAsCommissioner ? 'Edit League' : 'Edit Team Name';
  }

  get submitLabel(): string {
    if (!this.isEditing) return 'Create League';
    return this.editingAsCommissioner ? 'Update League' : 'Update Team Name';
  }

  onSubmit(): void {
    this.saved.emit(this.league);
  }

  onClose(): void {
    this.closed.emit();
  }
}
